// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-video-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: color-mix(in srgb, var(--c-black) 45%, transparent);
}

.ad-video-modal {
  width: min(720px, 100%);
  max-height: min(90vh, 640px);
  display: flex;
  flex-direction: column;
  background: var(--c-white);
  border-radius: var(--border-radius);
  box-shadow: var(--ui-shadow-lg);
  overflow: hidden;
}

.ad-video-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
}

.ad-video-modal__title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ad-video-modal__close {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--text2);
  cursor: pointer;
}

.ad-video-modal__close:hover {
  background: var(--bg-soft);
  color: var(--text);
}

.ad-video-modal__body {
  padding: 12px;
  background: var(--bg-soft);
}

.ad-video-modal__player {
  display: block;
  width: 100%;
  max-height: min(70vh, 520px);
  border-radius: 6px;
  background: var(--c-black);
}

.ad-video-modal__fallback {
  padding: 24px 16px;
  text-align: center;
  font-size: 13px;
  color: var(--text2);
}

.ad-video-modal__fallback p {
  margin: 0 0 12px;
}

.ad-video-modal__library-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--c-teal-active);
  text-decoration: none;
}

.ad-video-modal__library-link:hover {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/mi/AdVideoPlaybackModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+DAA+D;AACjE;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,mCAAmC;EACnC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".ad-video-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: color-mix(in srgb, var(--c-black) 45%, transparent);\n}\n\n.ad-video-modal {\n  width: min(720px, 100%);\n  max-height: min(90vh, 640px);\n  display: flex;\n  flex-direction: column;\n  background: var(--c-white);\n  border-radius: var(--border-radius);\n  box-shadow: var(--ui-shadow-lg);\n  overflow: hidden;\n}\n\n.ad-video-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border);\n}\n\n.ad-video-modal__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ad-video-modal__close {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text2);\n  cursor: pointer;\n}\n\n.ad-video-modal__close:hover {\n  background: var(--bg-soft);\n  color: var(--text);\n}\n\n.ad-video-modal__body {\n  padding: 12px;\n  background: var(--bg-soft);\n}\n\n.ad-video-modal__player {\n  display: block;\n  width: 100%;\n  max-height: min(70vh, 520px);\n  border-radius: 6px;\n  background: var(--c-black);\n}\n\n.ad-video-modal__fallback {\n  padding: 24px 16px;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text2);\n}\n\n.ad-video-modal__fallback p {\n  margin: 0 0 12px;\n}\n\n.ad-video-modal__library-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-teal-active);\n  text-decoration: none;\n}\n\n.ad-video-modal__library-link:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
